import { Panel } from "@freightsimple/ui-core/PageLayout/Panel";
import { Link } from "@freightsimple/ui-core/Typography/Link";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { T } from "@freightsimple/ui-core/Typography/T";
import type { CountryCode } from "@freightsimple/generated-dashboard-openapi-client/models/CountryCode";
import type moment from "moment";
import { memo } from "react";
import BookShipmentSection from "../CustomComponents/BookShipmentSection";
import { BookShipmentPickupDateInput } from "../Inputs/BookShipmentPickupDateInput";

interface PickupDatePanelProps {
  pickupCountry?: CountryCode | undefined;
  pickupDate: moment.Moment;
  setPickupDate: (_: moment.Moment) => void;
  index: number;
}

// Memoized: the details screen re-renders on every keystroke elsewhere in the
// form, and the two-month calendar is expensive to redraw.
export default memo(function BookShipmentPickupDatePanel(
  props: PickupDatePanelProps,
) {
  return (
    <BookShipmentSection
      id="pickup-date-section"
      index={props.index}
      width="medium"
      header="Pickup Date"
      description={
        // Two paragraphs, as Cargo had them. Bare <T> so each inherits the
        // StepHeader subtitle's size and weight rather than restating it.
        <Stack gap={2}>
          <T>
            A pickup can be booked within one month. While most pickups happen
            on the requested date, this is not guaranteed. Pickup dates can be
            changed before and after booking.
          </T>
          <T>
            Read more about pickup dates and ensuring your shipments are on-time{" "}
            <Link
              external
              href="https://help.freightsimple.com/using-freightsimple/quoting/pickup-date"
            >
              here
            </Link>
            .
          </T>
        </Stack>
      }
    >
      <Panel collapseOnNarrow>
        {/* The two months need less than the panel's width, so they sit in the
            middle of it rather than hugging the left edge — the same as the
            insurance panel does with its toggle. */}
        <Stack align="center">
          <BookShipmentPickupDateInput
            date={props.pickupDate.format("YYYY-MM-DD")}
            onDateChange={props.setPickupDate}
            country={props.pickupCountry}
          />
        </Stack>
      </Panel>
    </BookShipmentSection>
  );
});
